import { jsPDF } from "jspdf";

export const PdfExport = (textData, mailboxOwner) => {
  const { body, from, subject, attachments, toAddresses } = textData;

  const pageWidth = 8.5;
  const lineHeight = 1.2;
  const margin = 0.5;
  const maxLineWidth = pageWidth - margin * 2;
  const fontSize = 12;
  const doc = new jsPDF({
    unit: "in",
    lineHeight: lineHeight
  });

  const toField = toAddresses.length > 0 ? toAddresses : mailboxOwner;

  const pdfText =
    "From: " +
    from +
    "\n To : " +
    toField +
    "\n Subject: " +
    subject +
    "\n" +
    body;
  const textLines = doc
    .setFontSize(fontSize)
    .splitTextToSize(pdfText, maxLineWidth);

  //IT CREATES A NEW PDF PAGE
  let n = 0;
  let lineStart = 0;
  let lineEnd = 53;
  while (textLines.length > 53 * n) {
    if (n > 0) {
      doc.addPage("a4");
    }
    doc.text(textLines.slice(lineStart, lineEnd), margin, margin);
    //adds page numbers to the pdf
    //doc.text([`\n page ${n + 1}`, ...textLines.slice(lineStart, lineEnd)], margin, margin);
    n++;
    lineStart = lineEnd;
    lineEnd += 53;
  }

  let attachmentNames = attachments.map((el) => el.name + "\n");
  if (attachmentNames.length > 0) {
    doc.addPage("a4");
    doc.text(
      "Attachements to the email:\n" + attachmentNames?.join(""),
      margin,
      margin,
      {
        maxWidth: maxLineWidth
      }
    );
  }
  doc.save(`${new Date().toLocaleDateString()}_From_${from}.pdf`);
};
